export const LOGIN_USER_REQUEST = "LOGIN_USER_REQUEST";
export const LOGIN_USER_FAILURE = "LOGIN_USER_FAILURE";
export const LOGIN_USER_SUCCESS = "LOGIN_USER_SUCCESS";
export const LOGOUT_USER = "LOGOUT_USER";
export const UPDATE_PROFILE = "UPDATE_PROFILE";
export const UPDATE_EMAIL_VERIFICATION = "UPDATE_EMAIL_VERIFICATION";
export const SHOW_LOGIN_MODAL = "SHOW_LOGIN_MODAL";
export const REDIRECT_AFTER_LOGIN = "REDIRECT_AFTER_LOGIN";
export const SET_IS_PLATFORM_INVITE_LOADING = "SET_IS_PLATFORM_INVITE_LOADING";
export const SET_PLATFORM_INVITE = "SET_PLATFORM_INVITE";
export const UPDATE_PROFILE_KEYS = "UPDATE_PROFILE_KEYS";
export const UPDATE_GAMEPLAYER_PROFILE_KEYS = "UPDATE_GAMEPLAYER_PROFILE_KEYS";
export const SHOW_OAUTH_REGISTER_MODAL = "SHOW_OAUTH_REGISTER_MODAL";
export const CONTACT_INFO = "CONTACT_INFO";
export const AUTH_PROVIDER = "AUTH_PROVIDER";
export const UPDATE_TAG_LINE = "UPDATE_TAG_LINE";
export const SHOW_SHORTLIST_MODAL = "SHOW_SHORTLIST_MODAL";
